/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR) */
import { readNativeAuthRequest } from '../components/auth/native-auth-request.utils';

/** Return intent is routing metadata, never tenant authority or an arbitrary redirect URL. */
export function readWorkspaceEntryIntent(href: string, applicationCode: string): { applicationCode: string; root: string } | null {
  try {
    const url = new URL(href);
    if (applicationCode !== 'APPS') return null;
    const target = String(url.searchParams.get('appCode') ?? 'APPS').toUpperCase();
    if (!/^[A-Z][A-Z0-9_]{1,39}$/.test(target) || target.startsWith('SYS_')) return null;
    const root = `/${target.toLowerCase()}`;
    const returnTo = url.searchParams.get('returnTo');
    // A central entry never carries an entity URL into a different customer's database.
    if (returnTo && returnTo !== root && !returnTo.startsWith(`${root}/`)) return null;
    if (returnTo && (returnTo.includes('\\') || /[\u0000-\u0020]/u.test(returnTo) || returnTo.includes('//') || returnTo.includes('%'))) return null;
    return { applicationCode: target, root };
  } catch { return null; }
}

export function buildAppsLoginUrl(appsUrl: string, currentHref: string, applicationCode: string): string | null {
  try {
    const current = new URL(currentHref);
    const apps = new URL(appsUrl, current.origin);
    if (apps.origin !== current.origin || apps.username || apps.password || !['http:', 'https:'].includes(apps.protocol)
      || !/^[A-Z][A-Z0-9_]{1,39}$/.test(applicationCode) || applicationCode.startsWith('SYS_')) return null;
    apps.pathname = `${apps.pathname.replace(/\/login\/?$/, '').replace(/\/$/, '')}/login`;
    apps.search = new URLSearchParams({ appCode: applicationCode, returnTo: `/${applicationCode.toLowerCase()}` }).toString();
    // Native approval remains in its originating product. Only the public continuation UUID is carried.
    const native = readNativeAuthRequest(current.hash);
    apps.hash = native ? `native_request=${native}` : '';
    return apps.toString();
  } catch { return null; }
}

export function workspaceProductRoot(basePath: string): string {
  const path = basePath.replace(/\/$/, '');
  return path && /^\/[a-zA-Z0-9_/-]+$/.test(path) && !path.includes('//') ? path : '/';
}
